import { cilGroup } from "@coreui/icons";
import CIcon from "@coreui/icons-react";
import { CButton, CCol, CFormRange, CRow } from "@coreui/react";
import { ErrorMessage, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { addUserSchema } from "../../../common/Validation";
import adminAxiosInstance, {
  commonAxiosInstance,
  imageAxiosInstance,
} from "../../../config";
import { ErrorImage } from "../../assets";
import SweetAlert from "../../../helper/SweetAlert";
import PhoneInput from "react-phone-input-2";
const UserManagement = () => {
  const navigate = useNavigate();
  const [imageData, setImageData] = useState();
  // const [content, setContent] = useState();
  const [loading, setLoading] = useState(false);
  const [countryList, setCountryList] = useState();
  const [url, setUrl] = useState(ErrorImage);
  const [employeMentStatus, setEmployeMentStatus] = useState("");
  const [howHearAboutUs, setHowHearAboutUs] = useState("");
  const [userTypeArray, setUserTypeArray] = useState([]);
  const [checkRel, setCheckRel] = useState(false);
  const [checkEquity, setCheckEquity] = useState(false);
  // const [addressLink, setAddressLink] = useState("");
  const [totalInvestment, setTotalInvestment] = useState(0);
  const [greenUrl, setGreenUrl] = useState("");
  const [fatcaUrl, setFatcaUrl] = useState("");
  const [residenceUrl, setResidenceUrl] = useState("");
  const token = localStorage.getItem("token");

  const [fatcaQuesiton, setFatcaQuesiton] = useState([
    {
      isFav: false,
      label: "Found guilty of any criminal offence.",
    },
    {
      isFav: false,
      label:
        "A subject of any fine in a civil proceeding of fraud, misfeasance, or other misconduct.",
    },
    {
      isFav: false,
      label:
        "The subject of a judgement or agreed settlement in a civil proceeding exceeding a sum equivalent to USD 10,000/- or more.",
    },
    {
      isFav: false,
      label:
        "Disqualified from acting as a director or taking part in the management of a company",
    },
    {
      isFav: false,
      label:
        "Bankrupt or the director or a person concerned in the management of a company which has gone in liquidation or administration.",
    },
  ]);
  const uploadFile = async (e) => {
    let file = e.target.files[0];
    // console.log("file====>", file);
    if (file !== undefined) {
      // console.log("dbdhcbdcdbhcbdhcbh0", file);
      // setLoading(true);
      var formdata = new FormData();
      formdata.append("image", file);
      // console.log("formdata===>", formdata);
      try {
        const response = await imageAxiosInstance.post("/upload", formdata, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        // console.log("respons=====dede==>", response);
        setImageData(response.data?.data[0]?.mediaLink);
        // setLoading(false);
      } catch (error) {
        // setLoading(false);
        // console.log("error====>", error);
      }
    }
  };
  const handleLabel = (e, index) => {
    // console.log("eeeeeee", e.target.value);
    let abc = [...fatcaQuesiton];
    abc[index].isFav = e.target.value == "false" ? true : false;
    // console.log("acacacac-->", abc);
    setFatcaQuesiton(abc);
  };
  const uploadFileTwo = async (e, values) => {
    let file = e.target.files[0];
    // console.log("file====>", file);
    if (file !== undefined) {
      // console.log("dbdhcbdcdbhcbdhcbh0", file);
      // setLoading(true);
      var formdata = new FormData();
      formdata.append("image", file);
      // console.log("formdata===>", formdata);
      try {
        const response = await imageAxiosInstance.post("/upload", formdata, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        // console.log("respons=====dede==>", response);
        setResidenceUrl(response.data?.data[0]?.mediaLink);
        // setLoading(false);
      } catch (error) {
        // setLoading(false);
        // console.log("error====>", error);
      }
    }
  };
  const uploadFileThree = async (e) => {
    let file = e.target.files[0];
    // console.log("file====>", file);
    if (file !== undefined) {
      // console.log("dbdhcbdcdbhcbdhcbh0", file);
      // setLoading(true);
      var formdata = new FormData();
      formdata.append("image", file);
      // console.log("formdata===>", formdata);
      try {
        const response = await imageAxiosInstance.post("/upload", formdata, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        // console.log("respons=====dede==>", response);
        setGreenUrl(response.data?.data[0]?.mediaLink);
        // setLoading(false);
      } catch (error) {
        // setLoading(false);
        // console.log("error====>", error);
      }
    }
  };
  const uploadFileFour = async (e) => {
    let file = e.target.files[0];
    // console.log("file====>", file);
    if (file !== undefined) {
      // console.log("dbdhcbdcdbhcbdhcbh0", file);
      // setLoading(true);
      var formdata = new FormData();
      formdata.append("image", file);
      // console.log("formdata===>", formdata);
      try {
        const response = await imageAxiosInstance.post("/upload", formdata, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        // console.log("respons=====dede==>", response);
        setFatcaUrl(response.data?.data[0]?.mediaLink);
        // setLoading(false);
      } catch (error) {
        // setLoading(false);
        // console.log("error====>", error);
      }
    }
  };

  // const addressProof = async (e) => {
  //   let file = e.target.files[0];
  //   // setIsFileChanged(true);
  //   // setImageLoading(true);
  //   var formdata = new FormData();
  //   formdata.append("image", file);
  //   try {
  //     const response = await imageAxiosInstance.post("/upload", formdata, {
  //       headers: {
  //         "Content-Type": "multipart/form-data",
  //       },
  //     });
  // console.log("img---respon-->", response);
  //     setAddressLink(response?.data?.data[0].mediaLink);
  //   } catch (error) {
  // console.log("img==>upload---->error", error);
  //   }
  // };
  const countryData = async () => {
    try {
      const response = await commonAxiosInstance.get("/countryList");
      // console.log(response);
      setCountryList(response?.data?.data);
    } catch (error) {
      // console.log("error--->", error);
    }
  };
  // console.log("country---list---->", countryList);

  const onCheck = (e) => {
    let { value, checked } = e.target;
    // console.log("cdssd", checked, value);
    if (checked) {
      setUserTypeArray([...userTypeArray, value]);
    } else {
      setUserTypeArray(userTypeArray.filter((e) => e !== value));
    }
  };
  // console.log("userTypeArray", userTypeArray);

  const handleChangeInvest = (values, index, e) => {
    let abc = [...values.approximateBreakupNetWorth];
    abc[index].value = e;

    // console.log("values--->", abc);
    let initialValues = 0;
    // let sunTotal = abc.reduce(
    //   (previousValue, currentValue) => previousValue.value + currentValue.value,
    //   initialValues
    // );
    // let total = 0;
    abc.map((item) => {
      // item.value = Number(item?.value);
      // if (typeof item?.value == number) {
      initialValues += Number(item?.value);
      // }
    });

    // console.log("ssssss", previousValue, "kkkkkkkkkkkk", currentValue);
    // console.log("sunTottal--->", initialValues);
    setTotalInvestment(initialValues);
  };

  const handleFormSubmit = async (values) => {
    // console.log("newuservalues===>", values);

    try {
      // console.log("form-value===>", values);
      const response = await adminAxiosInstance.post(
        "/user/create",
        {
          ...values,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      // console.log("response===>", response);
      SweetAlert({
        icon: "success",
        text: response?.data?.msg || "you data has Submit",
        title: "Success",
        timer: "1500",
      });
      navigate("/admin/userlist");
    } catch (err) {
      console.log("err ==>", err?.response?.data?.mgs);
      SweetAlert({
        icon: "error",
        text: err?.response?.data?.msg || "something Went Wrong!",
        title: "Warning!",
      });
    }
  };
  useEffect(() => {
    if (imageData !== undefined) {
      setUrl(imageData);
      setLoading(false);
    }
  }, [imageData]);
  useEffect(() => {
    countryData();
  }, []);
  // console.log("image--data--->", imageData);

  return (
    <>
      <div className="d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-center gap-2">
          <CIcon icon={cilGroup} size="xl" />
          <h5 className="mb-0">User Details</h5>
        </div>
        <div>
          <Link
            className="text-decoration-none text-white"
            to="/admin/userlist"
          >
            <button className="text-white btn cstm-adminbtn">Go Back</button>
          </Link>
        </div>
      </div>

      <div>
        <Formik
          initialValues={{
            userName: "",
            email: "",
            mobile: "",
          }}
          onSubmit={handleFormSubmit}
          // validationSchema={addUserSchema}
        >
          {({
            values,
            handleChange,
            handleBlur,
            setFieldValue,
            isSubmitting,
            errors,
            touched,
          }) => (
            <div className="border-top border-success border-3 mt-3 p-2 pt-3">
              <h5 className="fw-normal">Enter User Details </h5>
              <Form>
                <CRow className="align-items-center">
                  <CCol sm={6}>
                    <div>
                      <div>
                        <div className="form-group mt-3">
                          <label htmlFor="name" className="fw-semibold mb-2">
                            First Name
                          </label>
                          <input
                            type="text"
                            className={`form-control${
                              errors.userName && touched.userName
                                ? " is-invalid"
                                : ""
                            }`}
                            name="userName"
                            id="userName"
                            value={values.userName}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                        </div>
                        <div className="text-danger">
                          <ErrorMessage name="userName" />
                        </div>
                      </div>

                      {/* <div className="mt-5">
                        <PhoneInput
                          international
                          defaultCountry={"in"}
                          country="in"
                          // defaultCountry="RU"
                          inputProps={{
                            name: "",
                            required: true,
                          }}
                          specialLabel="Referral Number"
                          countryCallingCodeEditable={true}
                          name="referralCode"
                          value={values.referralCode}
                          onChange={(e) => {
                            setFieldValue("referralCode", e);
                            // console.log("eee-->", e);
                          }}
                          onBlur={handleBlur}
                        />
                      </div> */}

                      {/* <div className="form-group mt-3">
                        <label htmlFor="name" className="fw-semibold mb-2">
                          Registe & Type
                        </label>
                        <div>
                          <input
                            type="checkbox"
                            // className={`form-control`}

                            id="userType"
                            value={"Real Estate"}
                            checked={checkRel}
                            onClick={(e) => {
                              onCheck(e);
                              setCheckRel(e.target.checked);
                              // console.log("vvvvv", e.target.checked);
                            }}
                          />
                          <label>Real Estate</label>
                        </div>
                        <div>
                          <input
                            type="checkbox"
                            // className={`form-control`}
                            // name="userType[0]"
                            id="userType"
                            checked={checkEquity}
                            value={"Equity"}
                            // checked={}
                            onClick={(e) => {
                              onCheck(e);
                              setCheckEquity(e.target.checked);
                            }}
                            // onBlur={handleBlur}
                          />
                          <label>Equity</label>
                        </div>
                      </div> */}
                      <CCol xl={12} lg={12}>
                        {/* <div className="border-1">
                          <label
                            htmlFor="addressProof"
                            className="fw-semibold mb-2"
                          >
                            Address Proof
                          </label>
                          <input
                            // placeholder="Enter Stock Name"
                            type="file"
                            name="addressProof"
                            value={values.addressProof}
                            onBlur={handleBlur}
                            onChange={(e) => {
                              addressProof(e);
                              setFieldValue("addressProof", e.target.value);
                              handleChange(e);
                            }}
                            className="form-control"
                          />
                          <div className="mt-2 mb-3">
                            <label>Link :-</label>
                            <a href={addressLink} target="_blank">
                              {addressLink}
                            </a>
                          </div>
                        </div> */}
                      </CCol>
                      {/* <div className="form-group mt-3">
                        <label
                          htmlFor="userUniqueCode"
                          className="fw-semibold mb-2"
                        >
                          User Unique Code
                        </label>
                        <input
                          type="text"
                          className={`form-control`}
                          name="userUniqueCode"
                          id="userUniqueCode"
                          value={values.userUniqueCode}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          disabled
                        />
                      </div> */}
                      {/* <div className="form-group mt-3">
                        <label
                          htmlFor="onfidoApplicantId"
                          className="fw-semibold mb-2"
                        >
                          Onfido Applicant Id
                        </label>
                        <input
                          type="text"
                          className={`form-control`}
                          name="onfidoApplicantId"
                          disabled
                          id="onfidoApplicantId"
                          value={values.onfidoApplicantId}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                      </div> */}
                      {/* <div className="form-group mt-5">
                        <label
                          htmlFor="onfidoVerification"
                          className="fw-semibold mb-2"
                        >
                          Onfido Verification
                        </label>

                        <select
                          // defaultValue={item?.status}
                          id="userState"
                          className={`form-select`}
                          name="onfidoVerification"
                          value={values.onfidoVerification}
                          onChange={(e) => {
                            setFieldValue("onfidoVerification", e.target.value);
                            // handleChange(e);
                            // console.log(e.target.value);
                          }}
                          // disabled
                          onBlur={handleBlur}
                        >
                          <option value="">Choose</option>
                          <option value={true}>Yes</option>
                          <option value={false}>No</option>
                        </select>
                      </div> */}
                      {/* <div className="form-group mt-3">
                        <label htmlFor="completedStep" className="fw-semibold mb-2">
                          Completed Step
                        </label>
                        <input
                          type="text"
                          className={`form-control`}
                          name="completedStep"
                          id="completedStep"
                          value={values.completedStep}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          // disabled
                        />
                      </div> */}
                      {/* <div className="form-group mt-5">
                        <label htmlFor="country" className="fw-semibold mb-2">
                          Nationality
                        </label>
                        <select
                          type="text"
                          className={`form-select${
                            errors.nationality && touched.nationality
                              ? " is-invalid"
                              : ""
                          }`}
                          id="country"
                          name="nationality"
                          value={values.nationality}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        >
                          <option value=""> Choose</option>
                          {countryList?.map((item, i) => (
                            <option key={i} value={item[`Alpha-3 code`]}>
                            
                              {item?.Country}
                            </option>
                          ))}
                        </select>
                      </div> */}
                      {/* <div className="text-danger">
                        <ErrorMessage name="nationality" />
                      </div> */}
                      {/* <div className="form-group mt-5">
                        <label
                          htmlFor="address"
                          className="form-label fw-label"
                        >
                          Address
                        </label>
                        <textarea
                          rows="4"
                          cols="50"
                          type="text"
                          id="address"
                          name="address"
                          placeholder="Address"
                          value={values.address}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          className={`form-control${
                            errors.address && touched.address
                              ? " is-invalid"
                              : ""
                          }`}
                        ></textarea>
                      </div>
                      <div className="text-danger">
                        <ErrorMessage name="address" />
                      </div> */}
                      {/* <div className="form-group mt-5">
                        <label htmlFor="postalCode" className="fw-semibold mb-2">
                          Postal Code
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="postalCode"
                          name="postalCode"
                          value={values.postalCode}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                      </div> */}

                      {/* <div className="text-danger">
                        <ErrorMessage name="city" />
                      </div> */}

                      {/* <div className="form-group mt-5">
                        <label htmlFor="declaration" className="fw-semibold mb-2">
                          Country of Current Residence Document:
                        </label>

                        <select
                          // defaultValue={item?.status}
                          id="userState"
                          className={`form-select`}
                          name="countryOfCurrentResidence.name"
                          value={values.countryOfCurrentResidence.name}
                          onChange={(e) => {
                            setFieldValue(
                              "countryOfCurrentResidence.name",
                              e.target.value
                            );
                            // handleChange(e);
                            // console.log(e.target.value);
                          }}
                          onBlur={handleBlur}
                        >
                          <option value={""}>Choose...</option>
                          <option value="residence visa">Residence visa</option>
                          <option value="any government issued local ID,">
                            Any government issued local ID,
                          </option>
                          <option value="others, please specify_____">
                            Others, please specify_____
                          </option>
                        </select>
                      </div> */}
                      {/* {values.countryOfCurrentResidence.name ==
                      "others, please specify_____" ? (
                        <div className="my-2">
                          <input
                            type="text"
                            className="form-control"
                            id="resent"
                            placeholder="Field Name"
                            name="countryOfCurrentResidence.residence"
                            value={values.countryOfCurrentResidence.residence}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                        </div>
                      ) : (
                        <></>
                      )} */}
                      {/* {values.countryOfCurrentResidence.name != "" ? (
                        <div className="mt-3">
                          <div className="text-center">
                            <img
                              className="img-fluid max_img_view_admin"
                              src={residenceUrl ? residenceUrl : ErrorImage}
                              alt="blog"
                            />
                          </div>
                          <div className="form-group mt-3">
                            <label
                              htmlFor="featured_image"
                              className="fw-semibold mb-2"
                            >
                              Residence Image
                            </label>
                            <input
                              type="file"
                              // name="featured_image"
                              className="form-control"
                              id="featured_image"
                              accept="image/*"
                              // value={values.featured_image}
                              // onBlur={handleBlur}
                              onChange={(e) => {
                                uploadFileTwo(e, values);
                                // setFieldValue("featured_image", e.target.value);
                                // uploadFile(e);
                                // handleChange(e);
                              }}
                            />
                          </div>
                        </div>
                      ) : (
                        <></>
                      )} */}
                      {/* <div className="mt-3 d-flex">
                        <input
                          type="checkbox"
                          // className={`form-control`}
                          name="citizenOfUSA"
                          id="userType"
                          value={values.citizenOfUSA}
                          // checked={checkRel}
                          onClick={(e) => {
                            // handleChange(e);
                            setFieldValue(
                              "citizenOfUSA",
                              Boolean(e.target.checked)
                            );
                            // onCheck(e);
                            // setCheckRel(e.target.checked);
                            // console.log("vvvvv", e.target.checked);
                          }}
                        />
                        <label className="me-3">
                          A citizen/green card holder/or resident of United
                          States of America
                        </label>
                      </div> */}
                      {/* {values.citizenOfUSA ? (
                        <div className="mt-3">
                          <div className="text-center">
                            <img
                              className="img-fluid max_img_view_admin"
                              src={greenUrl ? greenUrl : ErrorImage}
                              alt="blog"
                            />
                          </div>
                          <div className="form-group mt-3">
                            <label
                              htmlFor="featured_image"
                              className="fw-semibold mb-2"
                            >
                              Residence Image
                            </label>
                            <input
                              type="file"
                              // name="featured_image"
                              className="form-control"
                              id="featured_image"
                              accept="image/*"
                              // value={values.featured_image}
                              // onBlur={handleBlur}
                              onChange={(e) => {
                                uploadFileThree(e);
                                // setFieldValue("featured_image", e.target.value);
                                // uploadFile(e);
                                // handleChange(e);
                              }}
                            />
                          </div>
                        </div>
                      ) : (
                        <></>
                      )} */}
                      {/* <div className="form-group mt-5">
                        <label htmlFor="declaration" className="fw-semibold mb-2">
                          Declaration
                        </label>

                        <select
                          // defaultValue={item?.status}
                          id="userState"
                          className={`form-select`}
                          name="declaration"
                          value={values.declaration}
                          onChange={(e) => {
                            setFieldValue("declaration", e.target.value);
                            // handleChange(e);
                            // console.log(e.target.value);
                          }}
                          onBlur={handleBlur}
                        >
                          <option value="">Choose</option>
                          <option value={"Yes"}>Yes</option>
                          <option value={"No"}>No</option>
                        </select>
                      </div> */}
                      {/* {console.log("tttttttt", values.declaration)} */}
                    </div>
                  </CCol>
                  <CCol sm={6}>
                    <div>
                      <div className="mt-3">
                        <PhoneInput
                          international
                          defaultCountry={"in"}
                          country="in"
                          // defaultCountry="RU"
                          inputProps={{
                            name: "Mobile No",
                            required: true,
                          }}
                          countryCallingCodeEditable={true}
                          name="mobile"
                          value={values.mobile}
                          onChange={(e) => {
                            setFieldValue("mobile", e);
                            // console.log("eee-->", e);
                          }}
                          onBlur={handleBlur}
                        />
                        {/* <label htmlFor="mobile" className="fw-semibold mb-2">
                          Mobile No.
                        </label>
                        <input
                          type="text"
                          className={`form-control${
                            errors.mobile && touched.mobile ? " is-invalid" : ""
                          }`}
                          name="mobile"
                          id="mobile"
                          value={values.mobile}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        /> */}
                      </div>
                      <div className="text-danger">
                        <ErrorMessage name="mobile" />
                      </div>
                    </div>
                  </CCol>
                  <CCol sm={6}>
                    <div>
                      <div className="form-group mt-3">
                        <label htmlFor="email" className="fw-semibold mb-2">
                          Email
                        </label>
                        <input
                          type="text"
                          className={`form-control${
                            errors.email && touched.email ? " is-invalid" : ""
                          }`}
                          id="email"
                          name="email"
                          value={values.email}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                      </div>
                      <div className="text-danger">
                        <ErrorMessage name="email" />
                      </div>
                    </div>
                  </CCol>
                  <CCol sm={6} className="">
                    {/* <div className="form-group mt-5">
                      <label htmlFor="howHearAboutUs" className="fw-semibold mb-2">
                        How Hear About Us
                      </label>
                      <select
                        // defaultValue={item?.status}
                        className={`form-select${
                          errors.howHearAboutUs && touched.howHearAboutUs
                            ? " is-invalid"
                            : ""
                        }`}
                        name="howHearAboutUs"
                        value={values.howHearAboutUs}
                        id="wealthSource"
                        onChange={(e) => {
                          handleChange(e);
                          setHowHearAboutUs(e.target.value);
                        }}
                        onBlur={handleBlur}
                      >
                        <option value="">Choose</option>
                        <option value="Referral Partner">
                          Referral Partner
                        </option>
                        <option value="Employee">Employee</option>
                        <option value="Business Associate">
                          Business Associate
                        </option>
                        <option value="Other">Other</option>
                      </select>
                    </div> */}
                    {/* <div className="text-danger">
                      <ErrorMessage name="howHearAboutUs" />
                    </div>
                    {howHearAboutUs == "Employee" ||
                    howHearAboutUs == "Referral Partner" ||
                    howHearAboutUs == "Business Associate" ? (
                      <>
                        <div className="form-group mt-5">
                          <label htmlFor="mobile" className="fw-semibold mb-2">
                            Code
                          </label>

                          <input
                            type="text"
                            className="form-control"
                            id="dpId"
                            name="code"
                            value={values.code}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                        </div>
                        <div className="form-group mt-5">
                          <label htmlFor="name" className="fw-semibold mb-2">
                            Name
                          </label>

                          <input
                            type="text"
                            className="form-control"
                            id="name"
                            name="name"
                            value={values.name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="form-group mt-5">
                          <label htmlFor="otherInput" className="fw-semibold mb-2">
                            Other Input
                          </label>

                          <input
                            type="text"
                            className="form-control"
                            id="otherInput"
                            name="otherInput"
                            value={values.otherInput}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                        </div>
                      </>
                    )} */}

                    {/* <div className="form-group mt-5">
                      <label htmlFor="city" className="fw-semibold mb-2">
                        Dp ID
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="dpId"
                        name="dpId"
                        value={values.dpId}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                    </div>
                    <div className="text-danger">
                      <ErrorMessage name="dpId" />
                    </div> */}
                    {/* <div className="form-group mt-5">
                      <label htmlFor="city" className="fw-semibold mb-2">
                        Dp Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="dpName"
                        name="dpName"
                        value={values.dpName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                    </div>
                    <div className="text-danger">
                      <ErrorMessage name="dpName" />
                    </div> */}
                    {/* <div className="form-group mt-5">
                      <label htmlFor="city" className="fw-semibold mb-2">
                        Client Id
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="clientId"
                        name="clientId"
                        value={values.clientId}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                    </div>
                    <div className="text-danger">
                      <ErrorMessage name="clientId" />
                    </div> */}
                    {/* <div className="form-group mt-5">
                      <label htmlFor="city" className="fw-semibold mb-2">
                        Client Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="clientName"
                        name="clientName"
                        value={values.clientName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                    </div>
                    <div className="text-danger">
                      <ErrorMessage name="clientName" />
                    </div> */}
                  </CCol>
                  {/* <CRow>
                    <CCol className="mt-5">
                      <div className="text-center">
                        <img
                          className="img-fluid max_img_view_admin"
                          src={urlLink}
                          alt="blog"
                        />
                      </div>
                      <div className="form-group mt-3">
                        <label
                          htmlFor="featured_image"
                          className="fw-semibold mb-2"
                        >
                          Aadhaar Front Image
                        </label>
                        <input
                          type="file"
                          name="featured_image"
                          className="form-control"
                          id="featured_image"
                          accept="image/*"
                          onChange={(e) => {}}
                        />
                      </div>
                    </CCol>
                    <CCol className="mt-5">
                      <div className="text-center">
                        <img
                          className="img-fluid max_img_view_admin"
                          alt="blog"
                        />
                      </div>
                      <div className="form-group mt-3">
                        <label
                          htmlFor="featured_image"
                          className="fw-semibold mb-2"
                        >
                          Aadhaar Back Image
                        </label>
                        <input
                          type="file"
                          name="featured_image"
                          className="form-control"
                          id="featured_image"
                          accept="image/*"
                          onChange={(e) => {}}
                        />
                      </div>
                    </CCol>
                    <CCol className="mt-5">
                      <div className="text-center">
                        <img
                          className="img-fluid max_img_view_admin"
                          alt="blog"
                        />
                      </div>
                      <div className="form-group mt-3">
                        <label
                          htmlFor="featured_image"
                          className="fw-semibold mb-2"
                        >
                          Pan Card Image
                        </label>
                        <input
                          type="file"
                          name="featured_image"
                          className="form-control"
                          id="featured_image"
                          accept="image/*"
                          onChange={(e) => {}}
                        />
                      </div>
                    </CCol>
                    <CRow className="mt-5">
                      <CCol>
                        <div className="text-center">
                          <img
                            className="img-fluid max_img_view_admin"
                            alt="blog"
                          />
                        </div>
                        <div className="form-group mt-3">
                          <label
                            htmlFor="featured_image"
                            className="fw-semibold mb-2"
                          >
                            Bank Check Image
                          </label>
                          <input
                            type="file"
                            name="featured_image"
                            className="form-control"
                            id="featured_image"
                            accept="image/*"
                            onChange={(e) => {}}
                          />
                        </div>
                      </CCol>
                      <CCol>
                        <div className="text-center">
                          <img
                            className="img-fluid max_img_view_admin"
                            src={urlLink}
                            alt="blog"
                          />
                        </div>
                        <div className="form-group mt-3">
                          <label
                            htmlFor="featured_image"
                            className="fw-semibold mb-2"
                          >
                            CML Upload
                          </label>
                          <input
                            type="file"
                            name="featured_image"
                            className="form-control"
                            id="featured_image"
                            accept="image/*"
                            onChange={(e) => {}}
                          />
                        </div>
                      </CCol>
                    </CRow>
                  </CRow> */}
                </CRow>
                <CCol>
                  <div>
                    <CButton
                      type="submit"
                      className="btn cstm-adminbtn text-white mt-3 px-5"
                      // onSubmit={(values)=>handleFormSubmit(values)}
                      // disabled={totalInvestment == 100 ? false : true}
                    >
                      Submit
                    </CButton>
                  </div>
                </CCol>
              </Form>
            </div>
          )}
        </Formik>
      </div>
    </>
  );
};

export default UserManagement;
